import type { Models } from "api/types";
import { DropdownSelector } from "molecules/containers/dropdown-selector/DropdownSelector";
import { ActionModal } from "molecules/modal-window/action-modal/ActionModal";
import { PricingPreview } from "pages/root/shop/PackagePDP/pricing-preview/PricingPreview";

type BuyAgainModalProps = {
  open: boolean;
  title: string;
  price: Models<"PackagePriceModel"> | undefined | null;
  package: Models<"PackageModel"> | undefined;
  platformUserPackage: Models<"PlatformUserPackageModel">;
  platform: Models<"PlatformModel">;
  cost: number;
  isPriceSet: boolean;
  listing: Models<"ListingModel">;
  onClose: () => void;
  onClickAddToCart: () => void;
  onClickDropdownSelector: () => void;
};

export const BuyAgainModal = ({
  open,
  title,
  price,
  package: $package,
  platformUserPackage,
  platform,
  cost,
  listing,
  isPriceSet,
  onClose,
  onClickAddToCart,
  onClickDropdownSelector,
}: BuyAgainModalProps) => {
  return (
    <ActionModal
      open={open}
      onClose={onClose}
      size="small"
      title={title}
      firstButtonLabel="Add to cart"
      onFirstButtonClick={onClickAddToCart}
      description={
        <div className="flex flex-col items-center gap-5">
          <div className="text-sub2 uppercase text-secondary">
            Confirm Quantity
          </div>
          <DropdownSelector
            text={
              price
                ? `${price?.quantity} ${
                    price?.quantity > 1
                      ? $package?.packageUnitType.pluralUnitType ?? "units"
                      : $package?.packageUnitType.singularUnitType ?? "unit"
                  }`
                : `${platformUserPackage.totalTreatmentAmount} ${
                    $package?.packageUnitType.pluralUnitType ?? "units"
                  }`
            }
            state="selected"
            onClick={onClickDropdownSelector}
          />
          <div className="w-full pb-5">
            <PricingPreview
              affirmEnabled={platform.platformSettings?.affirmEnabled}
              defaultPrice={cost}
              memberPrice={
                price?.membershipPrice ?? listing.membershipCost ?? undefined
              }
              isPriceSet={isPriceSet}
              packageUnitType={
                $package?.packageUnitType.singularUnitType ?? "unit"
              }
            />
          </div>
        </div>
      }
    />
  );
};
